import React from "react";

import UDefStandard from "features/Model/Enclosure/UserDefinedCodes/StandardLayers";
import UDefWindow from "features/Model/Enclosure/UserDefinedCodes/WindowLayers";

import StandardWall from "features/Model/Enclosure/ComponentList/Wall/Construction/WallStandardCode";
import StandardWindow from "features/Model/Enclosure/ComponentList/Window/Construction/StandardCode";
import StandardBasement from "features/Model/Enclosure/ComponentList/Basement/WallConstruction/StandardCode";
import StandardLintel from "features/Model/Enclosure/ComponentList/Wall/Construction/StandardCode";
import StandardCrawlspace from "features/Model/Enclosure/ComponentList/Crawlspace/WallConstruction/StandardCode";
import StandardPonyWall from "features/Model/Enclosure/ComponentList/Basement/PonyWall/StandardCode";
import StandardCeiling from "features/Model/Enclosure/ComponentList/Ceiling/Construction/StandardCode";
import StandardFloor from "features/Model/Enclosure/ComponentList/ExpFloor/Construction/StandardCode";
import StandardFloorHeader from "features/Model/Enclosure/ComponentList/FloorHeader/Construction/StandardCode";
import StandardFloorsAdded from "features/Model/Enclosure/ComponentList/Basement/FloorConstruction/StandardSlabCode";
import StandardFloorsAbove from "features/Model/Enclosure/ComponentList/Basement/FloorConstruction/StandardFloorsAboveCode";

export const CodeDrawer = ({ componentType = "Wall", codeType = "S", ...props }) => {
    const standardCodes = {
        Wall: StandardWall,
        Window: StandardWindow,
        BasementWall: StandardBasement,
        Ceiling: StandardCeiling,
        CeilingFlat: StandardCeiling,
        CrawlspaceWall: StandardCrawlspace,
        PonyWall: StandardPonyWall,
        Floor: StandardFloor,
        FloorHeader: StandardFloorHeader,
        FloorsAbove: StandardFloorsAbove,
        FloorsAdded: StandardFloorsAdded,
        Lintel: StandardLintel,
    };

    if (codeType === "U" && componentType === "Window") {
        return <UDefWindow componentType={componentType} {...props} />;
    }

    if (codeType === "U") {
        return <UDefStandard componentType={componentType} {...props} />;
    }

    const StandardCode = standardCodes[componentType];

    if (!StandardCode) {
        return null;
    }

    return <StandardCode {...props} />;
};

export const standardCodeFormName = (type) =>
    ({
        Wall: "wallInsType",
        Window: "windowType",
        BasementWall: "basementWallInsType",
        Ceiling: "ceilingInsType",
        CeilingFlat: "ceilingInsType",
        CrawlspaceWall: "crawlspaceWallInsType",
        Floor: "expFloorInsType",
        FloorHeader: "floorHeaderInsType",
        FloorsAbove: "floorsAboveInsType",
        FloorsAdded: "slabInsType",
        Lintel: "lintelInsType",
    }[type]);

export const uDefCodeFormName = (type) => {
    if (type === "Window") {
        return "windowUDef";
    }

    return "udefStandard";
};
